export default class HomePicto {
  constructor(el) {
    this.el = el
    this.btns = [...el.querySelectorAll('.home-picto--btn')]
    this.select = el.querySelector('.home-picto--select')
    this.cta = el.querySelector('.home-picto--cta')
    this.init()
  }

  init() {
    if (this.select) {
      this.select.addEventListener('change', () => {
        const selected = this.select.options[this.select.selectedIndex]
        this.setActive(this.select.value)
        if (this.cta) this.cta.href = selected.dataset.href || '#'
      })
    }
  }

  setActive(target) {
    this.btns.forEach(b => b.classList.remove('is-active'))
    const active = this.el.querySelector(`.home-picto--btn[data-target="${target}"]`)
    if (active) active.classList.add('is-active')
  }
}
